import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

export * from './pipes/index';

import { AbbreviatedNumberWithSuffixPipe } from './pipes/abbreviated-number-with-suffix.pipe';
import { CstDatePipe } from './pipes/cst-date.pipe';
import { FileTypeIconPipe } from './pipes/file-type-icon.pipe';
import { HasAnnualizedSpendPipe } from './pipes/has-annualized-spend.pipe';
import { MonthsBetweenPipe } from './pipes/months-between.pipe';
import { NfCurrencyPipe } from './pipes/nf-currency.pipe';
import { SpendDateRangePipe } from './pipes/spend-date-range.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { UnsafeHtmlPipe } from './pipes/unsafe-html.pipe';
import { FormatPlannedSpendLevelPipe } from './pipes/format-planned-spend-level.pipe';
import { FileSizePipe } from './pipes/file-size.pipe';
import { AddParenthesisPipe } from './pipes/add-parenthesis.pipe';
import { SavingsPercentagePipe } from './pipes/savings-percentage.pipe';
import { WithLoadingPipe } from './pipes/with-loading.pipe';

const moduleDependencies = [
  AbbreviatedNumberWithSuffixPipe,
  CstDatePipe,
  FileTypeIconPipe,
  HasAnnualizedSpendPipe,
  MonthsBetweenPipe,
  NfCurrencyPipe,
  SpendDateRangePipe,
  TruncatePipe,
  UnsafeHtmlPipe,
  FormatPlannedSpendLevelPipe,
  FileSizePipe,
  SavingsPercentagePipe,
  AddParenthesisPipe,
  WithLoadingPipe,
];

@NgModule({
  declarations: moduleDependencies,
  imports: [CommonModule],
  exports: moduleDependencies,
})
export class AngularPipesModule {}
